import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import videojs from 'video.js';
import VREPlayer from 'videojs-react-enhanced';
import 'video.js/dist/video-js.css';
import { isNull, set } from 'lodash';
import { Collapse } from '@material-ui/core';
import { Database } from '../../Managers/exports';

import { FaPlayCircle } from 'react-icons/fa'


export const VideoPlayer = prop => {
    const [options, setOptions] = useState(
        {
            src: null,
            controls: true, 
            // autoplay: "play",
        }
    )
    const videoRef = useRef()
    const leaving = new Subject()

    useEffect( async ()=> {
        try{
            let {video: src} = await Database._getRaw("https://us-central1-iiwtv-139f6.cloudfunctions.net/v1/videos/12781")
            setOptions({...options, src})


            let div = document.createElement("div")
            div.style="width: 0;\
            height: 0;\
            border-top: 0.4em solid transparent;\
            border-left: 0.6em solid white;\
            border-bottom: 0.4em solid transparent;\
            margin-left: 1.2em\
            "
            let el = document.getElementsByClassName("vjs-big-play-button")[0]
            el.appendChild(div)


        } catch(e) {
            console.error(e)
        }
    
        return () => leaving.next()
    }, [])

    const videojsOptions = {
      fluid: true,
    };



    return(
        <div style={{width: "100%"}}>
        <Collapse in={!!options.src}> 
            {!!options.src && <VREPlayer
                ref={videoRef}
                playerOptions={options}
                videojsOptions={videojsOptions}
                onError={console.error}
            />
            }
        </Collapse></div>

    )
}

// interface IPlayerOptions {
//     autoplay?: 'muted' | 'play' | 'any';
//     controls?: boolean;
//     height?: number;
//     loop?: boolean;
//     muted?: boolean;
//     playsinline?: boolean;
//     preload?: 'auto' | 'metadata' | 'none';
//     src?: string;
//     width?: number;
// }